import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import VideoCard from '@/components/feature/VideoCard';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { videos, videoCategories } from '@/mocks/videos';

const heroBanners = [
  {
    id: 'v004',
    title: '星际征途：新纪元',
    subtitle: '年度最受期待科幻巨制 · 人类星际殖民舰队遭遇未知文明',
    cta: '立即观看',
    gradient: 'from-black/60 via-black/30 to-black/60',
    cover: 'https://readdy.ai/api/search-image?query=An%20epic%20sci-fi%20movie%20banner%20with%20spaceships%20flying%20through%20colorful%20nebulae%2C%20distant%20planets%2C%20dramatic%20cosmic%20lighting%2C%20cinematic%20widescreen%20composition%2C%20adventure%20atmosphere%2C%20warm%20golden%20and%20deep%20space%20tones&width=1920&height=700&seq=hero-banner-001&orientation=landscape',
  },
  {
    id: 'v010',
    title: '笑傲江湖之风云再起',
    subtitle: '经典武侠巨著全新演绎 · 英雄辈出，江湖再起风云',
    cta: '立即观看',
    gradient: 'from-black/60 via-black/30 to-black/60',
    cover: 'https://readdy.ai/api/search-image?query=An%20epic%20wuxia%20film%20banner%20with%20warriors%20on%20misty%20mountain%20peaks%2C%20flowing%20robes%2C%20swords%2C%20golden%20sunrise%20light%2C%20ancient%20Chinese%20landscape%2C%20cinematic%20widescreen%2C%20dramatic%20atmosphere&width=1920&height=700&seq=hero-banner-002&orientation=landscape',
  },
  {
    id: 'v006',
    title: '灵境传说',
    subtitle: '国漫巅峰之作 · 少年修仙，斩妖除魔的奇幻冒险',
    cta: '立即观看',
    gradient: 'from-black/60 via-black/30 to-black/60',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20anime%20banner%20with%20floating%20temples%20and%20waterfalls%2C%20magical%20glowing%20elements%2C%20ethereal%20clouds%2C%20vibrant%20colors%2C%20epic%20illustration%20style%2C%20cinematic%20widescreen%20composition&width=1920&height=700&seq=hero-banner-003&orientation=landscape',
  },
];

export default function Home() {
  const [activeBanner, setActiveBanner] = useState(0);

  const featuredVideos = videos.filter((v) =>
    ['v004', 'v010', 'v006', 'v002', 'v009', 'v007'].includes(v.id)
  );

  const latestVideos = videos.filter((v) =>
    ['v001', 'v003', 'v005', 'v008', 'v011', 'v012'].includes(v.id)
  );

  const hotVideos = [...videos].sort((a, b) => b.views - a.views).slice(0, 8);

  return (
    <div className="min-h-screen bg-background-50">
      <ScrollToTop />
      <Navbar />

      <main>
        {/* Hero Banner */}
        <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden" aria-label="精选推荐">
          <div className="absolute inset-0 bg-background-900">
            <img
              src={heroBanners[activeBanner].cover}
              alt={heroBanners[activeBanner].title}
              className="w-full h-full object-cover object-top transition-opacity duration-700"
            />
          </div>
          <div className={`absolute inset-0 bg-gradient-to-b ${heroBanners[activeBanner].gradient}`}></div>

          <div className="absolute bottom-0 left-0 right-0 p-6 md:p-12">
            <div className="max-w-[1400px] mx-auto">
              <span className="inline-block bg-primary-500 text-background-50 text-xs font-label px-3 py-1 rounded-full mb-3 md:mb-4 whitespace-nowrap">
                精选推荐
              </span>
              <h1 className="text-2xl md:text-5xl font-heading font-bold text-background-50 mb-2 md:mb-3">
                {heroBanners[activeBanner].title}
              </h1>
              <p className="text-sm md:text-lg text-background-50/80 mb-4 md:mb-6 max-w-xl">
                {heroBanners[activeBanner].subtitle}
              </p>
              <Link
                to={`/article/${heroBanners[activeBanner].id}`}
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-lg font-label font-medium transition-all duration-200 whitespace-nowrap"
              >
                <i className="ri-play-fill text-xl"></i>
                {heroBanners[activeBanner].cta}
              </Link>
            </div>
          </div>

          <div className="absolute bottom-6 md:bottom-12 right-6 md:right-12 flex items-center gap-2">
            {heroBanners.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveBanner(index)}
                className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                  index === activeBanner
                    ? 'bg-primary-500 w-7'
                    : 'bg-background-50/50 hover:bg-background-50/80'
                }`}
                aria-label={`切换到第${index + 1}张推荐`}
              />
            ))}
          </div>

          <div className="absolute top-1/2 -translate-y-1/2 left-3 md:left-6">
            <button
              onClick={() => setActiveBanner((prev) => (prev - 1 + heroBanners.length) % heroBanners.length)}
              className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm hover:bg-background-50/40 text-background-50 transition-colors"
              aria-label="上一个"
            >
              <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
            </button>
          </div>
          <div className="absolute top-1/2 -translate-y-1/2 right-3 md:right-6">
            <button
              onClick={() => setActiveBanner((prev) => (prev + 1) % heroBanners.length)}
              className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm hover:bg-background-50/40 text-background-50 transition-colors"
              aria-label="下一个"
            >
              <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
            </button>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-6 md:py-8" aria-label="分类导航">
          <div className="flex items-center gap-3 overflow-x-auto pb-2 scrollbar-hide">
            {videoCategories.slice(0, 8).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-1.5 px-3 py-2 rounded-full bg-background-100 hover:bg-primary-100 text-foreground-600 hover:text-primary-700 text-sm font-medium transition-all duration-200 whitespace-nowrap flex-shrink-0"
              >
                <i className={`${cat.icon} text-base`}></i>
                {cat.name}
              </Link>
            ))}
          </div>
        </section>

        {/* Featured Section */}
        <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-4 md:py-6" aria-label="精选推荐">
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-lg md:text-2xl font-heading font-bold text-foreground-900 flex items-center gap-2">
              <i className="ri-star-fill text-accent-500"></i>
              精选推荐
            </h2>
            <Link
              to="/category/remen"
              className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap flex items-center gap-1"
            >
              查看更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
            {featuredVideos.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </section>

        {/* Hot Rankings */}
        <section className="bg-background-100 py-8 md:py-10" aria-label="热门排行榜">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-5">
              <h2 className="text-lg md:text-2xl font-heading font-bold text-foreground-900 flex items-center gap-2">
                <i className="ri-fire-fill text-primary-500"></i>
                热门排行榜
              </h2>
              <Link
                to="/category/remen"
                className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap flex items-center gap-1"
              >
                查看全部
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
              {hotVideos.map((video, index) => (
                <Link
                  key={video.id}
                  to={`/article/${video.id}`}
                  className="group flex items-center gap-3 bg-background-50 rounded-lg p-3 border border-background-200/70 hover-lift"
                >
                  <span className={`text-xl md:text-2xl font-heading font-bold flex-shrink-0 w-8 text-center ${
                    index < 3 ? 'text-primary-500' : 'text-foreground-300'
                  }`}>
                    {index + 1}
                  </span>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-medium text-foreground-800 truncate group-hover:text-primary-600 transition-colors">
                      {video.title}
                    </h3>
                    <p className="text-xs text-foreground-400 mt-0.5">{video.source}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Latest Section */}
        <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-8 md:py-10" aria-label="最新上线">
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-lg md:text-2xl font-heading font-bold text-foreground-900 flex items-center gap-2">
              <i className="ri-flashlight-fill text-accent-500"></i>
              最新上线
            </h2>
            <Link
              to="/category/zuixin"
              className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap flex items-center gap-1"
            >
              更多新片
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
            {latestVideos.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </section>

        {/* Source Platforms */}
        <section className="bg-background-100 py-8 md:py-10" aria-label="源站平台">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">
            <h2 className="text-lg md:text-2xl font-heading font-bold text-foreground-900 mb-3">
              聚合优质源站
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mb-6 max-w-2xl mx-auto">
              密桃视频聚合红桃视频、樱桃视频、茄子视频、糖心视频等热门平台资源，一站畅享海量高清内容
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-3xl mx-auto">
              {[
                { name: '红桃视频', slug: 'hongtao', icon: 'ri-heart-line', color: 'text-primary-500' },
                { name: '樱桃视频', slug: 'yingtao', icon: 'ri-star-line', color: 'text-accent-500' },
                { name: '茄子视频', slug: 'qiezi', icon: 'ri-movie-line', color: 'text-secondary-500' },
                { name: '糖心视频', slug: 'tangxin', icon: 'ri-hearts-line', color: 'text-primary-500' },
              ].map((platform) => (
                <Link
                  key={platform.slug}
                  to={`/category/${platform.slug}`}
                  className="flex flex-col items-center gap-3 p-5 bg-background-50 rounded-lg border border-background-200/70 hover-lift"
                >
                  <div className={`w-12 h-12 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-background-100`}>
                    <i className={`${platform.icon} ${platform.color} text-2xl md:text-3xl`}></i>
                  </div>
                  <span className="text-sm font-heading font-bold text-foreground-800">{platform.name}</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-8 md:py-10" aria-label="常见问题">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-lg md:text-2xl font-heading font-bold text-foreground-900 text-center mb-6">
              常见问题
            </h2>
            <div className="space-y-3">
              {[
                { q: '密桃视频需要付费吗？', a: '密桃视频完全免费！我们聚合了多个平台的优质内容，用户无需付费即可在线观看高清电影、电视剧、综艺和动漫。' },
                { q: '观看视频会卡顿吗？', a: '密桃视频采用先进的视频分发技术，支持智能缓冲和自适应码率，确保您在绝大多数网络条件下都能获得流畅的观看体验。' },
                { q: '支持哪些设备观看？', a: '密桃视频支持PC端、平板和手机浏览器访问，无需下载任何APP，打开浏览器即可畅享高清影视内容。' },
                { q: '视频资源更新快吗？', a: '我们拥有专业的内容运营团队，热门影片和剧集上线后会第一时间同步更新，确保您不会错过任何精彩内容。' },
              ].map((faq, index) => (
                <details key={index} className="group bg-background-100 rounded-lg border border-background-200/70">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-sm md:text-base font-medium text-foreground-800 list-none">
                    {faq.q}
                    <i className="ri-add-line group-open:hidden text-foreground-400"></i>
                    <i className="ri-subtract-line hidden group-open:block text-foreground-400"></i>
                  </summary>
                  <p className="px-5 pb-4 text-sm text-foreground-500 leading-relaxed">
                    {faq.a}
                  </p>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative w-full py-16 md:py-20 overflow-hidden" aria-label="开始观看">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20background%20with%20soft%20bokeh%20lights%2C%20movie%20theater%20atmosphere%2C%20dark%20ambient%20with%20golden%20glow%2C%20elegant%20texture%2C%20abstract%20cinematography%2C%20warm%20tones&width=1920&height=400&seq=cta-bg-home&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
          <div className="relative z-10 text-center px-4 max-w-2xl mx-auto">
            <h2 className="text-xl md:text-3xl font-heading font-bold text-background-50 mb-3">
              准备好开始观影之旅了吗？
            </h2>
            <p className="text-sm md:text-base text-background-50/70 mb-6">
              数千部高清影片等你发现，立即开启免费观影体验
            </p>
            <Link
              to="/category/zuixin"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-lg font-label font-medium text-base transition-all duration-200 whitespace-nowrap"
            >
              <i className="ri-play-circle-fill text-xl"></i>
              立即观看
            </Link>
          </div>
        </section>
      </main>

      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '密桃视频',
        url: 'https://www.mitaovideo.com/',
        description: '密桃视频聚合红桃视频、樱桃视频等热门站高清内容，免费全集在线观看不卡顿，茄子视频、糖心视频最新电影电视剧一网打尽，流畅播放体验。',
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://www.mitaovideo.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      }) }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          { '@type': 'Question', name: '密桃视频需要付费吗？', acceptedAnswer: { '@type': 'Answer', text: '密桃视频完全免费！我们聚合了多个平台的优质内容，用户无需付费即可在线观看高清电影、电视剧、综艺和动漫。' } },
          { '@type': 'Question', name: '观看视频会卡顿吗？', acceptedAnswer: { '@type': 'Answer', text: '密桃视频采用先进的视频分发技术，支持智能缓冲和自适应码率，确保您在绝大多数网络条件下都能获得流畅的观看体验。' } },
          { '@type': 'Question', name: '支持哪些设备观看？', acceptedAnswer: { '@type': 'Answer', text: '密桃视频支持PC端、平板和手机浏览器访问，无需下载任何APP，打开浏览器即可畅享高清影视内容。' } },
          { '@type': 'Question', name: '视频资源更新快吗？', acceptedAnswer: { '@type': 'Answer', text: '我们拥有专业的内容运营团队，热门影片和剧集上线后会第一时间同步更新，确保您不会错过任何精彩内容。' } },
        ],
      }) }} />
    </div>
  );
}